<template>
    <div>
      <h2 class="m_title solo mt-30">{{ $t('component.search_application.fields.search_application') }}</h2>
      <div class="component_6 pa-20">
        <v-row class="ma-0">
          <v-col cols="12" class="pa-0">
            <h2 class="nec_title">{{ $t('component.search_application.fields.search_application_desc') }}</h2>
            <div class="input_text_type_basic">
              <!--
                status : 1 check 일 경우  v-input--is-focused primary--text
                          2 close 일 경우  v-input--is-focused error--text

                          각 상황에 맞게 <v-text-field>에 class 추가
                          옵션으로 success, error 표현가능
                -->
              <h2 class="title_application_no">{{ $t('component.search_application.fields.application_no') }}</h2>
              <div class="application__new__wrap">
                <v-text-field
                  dense
                  outlined
                  placeholder="EG/P/YYYY/#####"
                  class="ft-size12 br_none email"
                  :success="isChecked && chkResult"
                  :error="isChecked && !chkResult"
                  :error-messages="errorText"
                  v-model="application_no"
                ></v-text-field>

                <v-btn
                  class="ft-size12 text-capitalize br_none new__check__btn"
                  dense
                  color="#a01c2a"
                  dark
                  width="95"
                  height="40"
                  v-if="!isChecked"
                  @click="fnCheck()"
                >{{ $t('common.button.check') }}</v-btn>

                <v-icon
                  class="status_icon new__type"
                  color="success"
                  style="top: 30%"
                  v-if="isChecked && chkResult"
                >mdi-check</v-icon>

                <v-icon
                  class="status_icon new__type"
                  color="red"
                  style="top: 30%"
                  v-if="isChecked && !chkResult"
                  @click="fnInitSearch()"
                >mdi-close</v-icon>
              </div>
            </div>
          </v-col>
        </v-row>
      </div>

      <h2 class="m_title solo mt-30" v-if="isChecked && chkResult">{{ $t('component.application_information.application_information')}}</h2>
      <div class="component_6" v-if="isChecked && chkResult">
        <v-row class="ma-0">
          <!-- RESULT -->
           <table class="table__header__style ty2">
            <colgroup>
              <col width="150px">
              <col width="*">
            </colgroup>
            <tbody>
              <tr>
                <td :class="{ 'nec_title text-left' : !this.$vuetify.rtl, 'nec_title text-right' : this.$vuetify.rtl}">
                  {{ $t('component.search_application.fields.title') }}
                </td>
                <td :class="{ 'ft-size12 text-left' : !this.$vuetify.rtl, 'ft-size12 text-right' : this.$vuetify.rtl}">
                  {{ $vuetify.rtl ? application.title_ar : application.title_en }}
                </td>
              </tr>
              <tr v-if="applicant_show_yn">
                <td :class="{ 'nec_title text-left' : !this.$vuetify.rtl, 'nec_title text-right' : this.$vuetify.rtl}">
                  {{ $t('component.search_application.fields.applicant') }}
                </td>
                <td :class="{ 'ft-size12 text-left' : !this.$vuetify.rtl, 'ft-size12 text-right' : this.$vuetify.rtl}">
                  {{ $vuetify.rtl ? application.applicant_name_list_ar : application.applicant_name_list_en }}
                </td>
              </tr>
            </tbody>
          </table>


        </v-row>
      </div>
    </div>
</template>

<script>
import requestApi from '@/utils/requestApi'
import utils from '@/utils/utils'
import eventBus from '@/utils/eventBus'

export default {
  props : {
    applicant_show_yn : Boolean,
    service_type_code : String
  },
  data(){
    return {
      application_no : '',
      isChecked : false,
      chkResult : false,
      errorText : null,

      application : {
        seq : '',
        application_no : '',
        filing_date : '',
        original_application_no : '',
        applicant_type_code : '',
        title_ar : '',
        title_en : '',
        receipt_date : '',
        first_priority_date : '',
        exhibition_date : '',
        exhbition_notes : '',
        publication_date : '',
        domain_type_code : '',
        grant_no : '',
        grant_date : '',
        ind_granted : '',
        expiration_date : '',
        international_application_no : '',
        international_filing_date : '',
        pct_publication_country_code : '',
        pct_publication_no : '',
        pct_publication_type : '',
        pct_publication_date : '',
        last_description_page : '',
        last_claims_page : '',
        ind_novelity : '',
        ind_inventive : '',
        ind_industrial : '',
        status_seq : '',
        abstract_ar : '',
        abstract_en : '',
        remark : '',
        domain_sub_type_code : '',
        applicant_name_list_ar : '',
        applicant_name_list_en : '',
        certification_file_key : '',
        ind_micro_org_protection : '',
        receipt_no : '',
        ind_same_app_inv : ''
      }

    }
  },
  watch: {
    application_no(){
      this.isChecked = false
      this.chkResult = false
      this.errorText = null
      this.$emit('change')
    }
  },
  mounted() {
    if(utils.isNull(this.applicant_show_yn)){
      this.applicant_show_yn = true
    }
    this.fnInitSearch()
  },
  methods: {
    fnInitSearch(){
      this.isChecked = false
      this.chkResult = false
      this.errorText = null
      this.application_no = ''
    },
    fnCheck(){
      if(!this.application_no){
        let snackBarOptions = {
          text: this.$t('common.message.enter_application_no')
        }
        eventBus.$emit('SHOW_SNACKBAR', snackBarOptions)
        return
      }

      let params = {
        application_no : this.application_no.trim(),
        service_type_code : this.service_type_code
      }

      requestApi({
        url: '/applications/search',
        method: 'GET',
        data: params,
        callback: (res) => {
          if (res.res_code === '200') {
            this.isChecked = true
            this.chkResult = true
            this.errorText = null

            this.application.seq = res.data.seq
            this.application.application_no = res.data.application_no
            this.application.filing_date = res.data.filing_date
            this.application.original_application_no = res.data.original_application_no
            this.application.applicant_type_code = res.data.applicant_type_code
            this.application.title_ar = res.data.title_ar
            this.application.title_en = res.data.title_en
            this.application.receipt_date = res.data.receipt_date
            this.application.first_priority_date = res.data.first_priority_date
            this.application.exhibition_date = res.data.exhibition_date
            this.application.exhbition_notes = res.data.exhbition_notes
            this.application.publication_date = res.data.publication_date
            this.application.domain_type_code = res.data.domain_type_code
            this.application.grant_no = res.data.grant_no
            this.application.grant_date = res.data.grant_date
            this.application.ind_granted = res.data.ind_granted
            this.application.expiration_date = res.data.expiration_date
            this.application.international_application_no = res.data.international_application_no
            this.application.international_filing_date = res.data.international_filing_date
            this.application.pct_publication_country_code = res.data.pct_publication_country_code
            this.application.pct_publication_no = res.data.pct_publication_no
            this.application.pct_publication_type = res.data.pct_publication_type
            this.application.pct_publication_date = res.data.pct_publication_date
            this.application.last_description_page = res.data.last_description_page
            this.application.last_claims_page = res.data.last_claims_page
            this.application.ind_novelity = res.data.ind_novelity
            this.application.ind_inventive = res.data.ind_inventive
            this.application.ind_industrial = res.data.ind_industrial
            this.application.status_seq = res.data.status_seq
            this.application.abstract_ar = res.data.abstract_ar
            this.application.abstract_en = res.data.abstract_en
            this.application.remark = res.data.remark
            this.application.domain_sub_type_code = res.data.domain_sub_type_code
            this.application.applicant_name_list_ar = res.data.applicant_name_list_ar
            this.application.applicant_name_list_en = res.data.applicant_name_list_en
            this.application.certification_file_key = res.data.certification_file_key
            this.application.ind_micro_org_protection = res.data.ind_micro_org_protection
            this.application.receipt_no = res.data.receipt_no
            this.application.ind_same_app_inv = res.data.ind_same_app_inv

            let chked_item = {
              chkResult : this.chkResult,
              application  : this.application
            }

            this.$emit('success', chked_item)
          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnCheck()
              })
            } else {
              this.isChecked = true
              this.chkResult = false

              this.errorText = this.$vuetify.rtl ? res.res_msg_ar : res.res_msg_en
              this.errorText = this.errorText.replace('<br>', '\r\n')

              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    }
  }
}
</script>

<style scoped>
.table__header__style.ty2 tbody tr:last-child td {
  border-bottom: 1px solid #eee !important;
}
</style>